import { Components, Theme } from '@mui/material'

export const CardOverrides = (theme: Theme): Components['MuiCard'] => ({
  defaultProps: {},
  styleOverrides: {
    root: {},
  },
})
